document.addEventListener('DOMContentLoaded', () => {
  mma_accordion();
})

function mma_accordion() {
  const accItems = document.querySelectorAll(".accordion__item");
  const accButtons = document.querySelectorAll(".accordion__btn");

  function toggleAcc() {
    const thisContent = this.nextElementSibling;
    const thisItem = this.parentNode;

    accItems.forEach((content) => {
      if (content.querySelector(".accordion__content") != thisContent) {
        content.classList.remove("accordion__item--active");
        content.querySelector(".accordion__content").style.maxHeight = null;
      }
    });

    if (!thisContent.style.maxHeight) {
      thisContent.style.maxHeight = thisContent.scrollHeight + "px";
      thisItem.classList.add("accordion__item--active");
    } else {
      thisContent.style.maxHeight = null;
      thisItem.classList.remove("accordion__item--active");
    }
  }

  accButtons.forEach((acc) => acc.addEventListener("click", toggleAcc));
}
